import { Text, Box } from "theme-ui";
import { useSelector } from "react-redux";

import * as styles from "./ImageToolTip.styles";
import { SvgOrImg } from "components";
import { selectUserChoices } from "store/app";
import { makeUrl } from "store/app/selectProductImagesForAngle";

export default function ImageToolTip({
  labelImage,
  image,
  children,
  imageWidth,
  imageHeight,
  backgroundColor,
  dangerouslySetLabel,
}) {
  const userChoices = useSelector(selectUserChoices);

  const newUrl = makeUrl({
    url: image,
    allFields: {},
    userChoices,
    imageURLValueToUse: "imageURLValueForTooltips",
  });

  return (
    <Box sx={styles.imageToolTip({ imageWidth })}>
      <Box
        sx={styles.image({
          image: newUrl,
          imageWidth,
          imageHeight,
          backgroundColor,
        })}
      />

      {dangerouslySetLabel ? (
        <Text
          sx={styles.text({ hasChildren: true })}
          variant="copy3Light"
          dangerouslySetInnerHTML={{ __html: dangerouslySetLabel }}
        >
          {labelImage && (
            <Box sx={styles.labelImageContainer}>
              <SvgOrImg
                src={labelImage.url}
                type={labelImage.type}
                alt={""}
                sx={styles.labelImageSvg({
                  color: labelImage.color,
                  type: labelImage.type,
                })}
              />
            </Box>
          )}
        </Text>
      ) : (
        <Text
          sx={styles.text({ hasChildren: Boolean(children) })}
          variant="copy3Light"
        >
          {labelImage && (
            <Box sx={styles.labelImageContainer}>
              <SvgOrImg
                src={labelImage.url}
                type={labelImage.type}
                alt={""}
                sx={styles.labelImageSvg({
                  color: labelImage.color,
                  type: labelImage.type,
                })}
              />
            </Box>
          )}
          {children}
        </Text>
      )}
    </Box>
  );
}
